<div>
  @if (value()) {
    <button mat-button (click)="onClickAction()">
      {{ value() }}
    </button>
  }
</div>
